export const uploadFileFormat = (fileList) => {
  console.log(fileList)
  if (fileList) {
    return fileList
  }
  return ''
}

export const echoFileFormat = (url) => {
  let list = []
  if (url !== null && url !== '' && url !== undefined) {
    list.push({url: url})
  }

  return list
}


